export function ReadOnlyNotice() {
  return <div className="px-4 text-sm font-medium text-gray-700">Read-only mode</div>;
}
